var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Key_icon_tag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets_Export",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vpn_key-black-18dp",
    transform: "translate(0.733333, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0082645,9.93939394 C12.1950413,7.53878788 9.99338843,5.81818182 7.40495868,5.81818182 C4.12231405,5.81818182 1.45454545,8.58969697 1.45454545,12 C1.45454545,15.410303 4.12231405,18.1818182 7.40495868,18.1818182 C9.99338843,18.1818182 12.1950413,16.4612121 13.0082645,14.0606061 L17.322314,14.0606061 L17.322314,18.1818182 L21.2892562,18.1818182 L21.2892562,14.0606061 L23.2727273,14.0606061 L23.2727273,9.93939394 L13.0082645,9.93939394 Z M7.40495868,14.0606061 C6.31404959,14.0606061 5.4214876,13.1333333 5.4214876,12 C5.4214876,10.8666667 6.31404959,9.93939394 7.40495868,9.93939394 C8.49586777,9.93939394 9.38842975,10.8666667 9.38842975,12 C9.38842975,13.1333333 8.49586777,14.0606061 7.40495868,14.0606061 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.af813bb262ea269ecc79bdb107861ec5.svg";
export { ForwardRef as ReactComponent };